// What the File templates grid says about a template built from a government
// form (VA 21-526EZ, 21-22a, …). The backend's monthly check sends
// `template.government_form = { tracked, status, label, needs_attention, forms }`
// — worst status across the template's forms wins.

const TONES = {
  outdated: 'alarm',     // VA published a newer revision, or withdrew the form
  not_found: 'alarm',
  error: 'warn',
  expiring: 'warn',      // our printed OMB date is within the warning window
  unknown_ours: 'warn',  // nobody recorded which revision we built from
};

/**
 * Ribbon text, tone and hover text for a template card, or null when nothing
 * needs attention (untracked templates, current forms, older responses).
 */
export const governmentFormRibbon = (template) => {
  const gov = template?.government_form;
  if (!gov || typeof gov !== 'object' || !gov.tracked) return null;
  const tone = TONES[gov.status];
  if (!tone) return null;

  const forms = Array.isArray(gov.forms) ? gov.forms : [];
  const flagged = forms.filter((f) => f && f.status === gov.status);
  const lines = (flagged.length ? flagged : forms)
    .map((f) => {
      const number = f.form_number ? `VA Form ${f.form_number}` : 'VA form';
      return f.status_detail ? `${number}: ${f.status_detail}` : number;
    });
  const hint = lines.length
    ? `${lines.join('\n')}\n\nThe template file is never swapped automatically — download VA's new revision and rebuild the mapping.`
    : gov.label;

  // "VA revised this form — MAY 2026" → two short lines on a 150px card.
  const [headline, when] = String(gov.label || '').split(' — ');
  return {
    tone,
    headline: headline || 'Check this form',
    when: when || '',
    hint,
    status: gov.status,
  };
};

export const needsGovernmentFormAttention = (template) =>
  Boolean(template?.government_form?.needs_attention);
